export default __webpack_public_path__ + "static/media/delete.8563afb9.gif";